/* eslint-disable @typescript-eslint/member-ordering */
import { animate, state, style, transition, trigger } from '@angular/animations';
import { ChangeDetectionStrategy, Component, ElementRef, HostBinding, Input, Renderer2 } from '@angular/core';

@Component({
  selector: 'mom-tooltip-box',
  templateUrl: 'tooltip-box.component.html',
  styleUrls: ['./tooltip-box.component.scss'],
  animations: [
    trigger('fade', [
      state('visible', style({ opacity: 1 })),
      state('invisible', style({ opacity: 0 })),
      transition('visible <=> invisible', animate('300ms linear'))
    ])
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TooltipBoxComponent {
  @HostBinding('@fade') fadeState = 'invisible';

  @Input() tooltipText: string;
  @Input() tooltipHtml: string;

  @Input()
  set posTop(val: number) {
    this.rnd.setStyle(this.getNativeElement(), 'top', `${val}px`);
  }

  @Input()
  set posLeft(val: number) {
    this.rnd.setStyle(this.getNativeElement(), 'left', `${val}px`);
  }

  constructor(public elementRef: ElementRef, private rnd: Renderer2) {}

  getNativeElement(): HTMLElement {
    return this.elementRef.nativeElement;
  }
}
